import { Paper, Stack, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";

import { useAuth } from "@/features/authentication";
import { PermissionEnum } from "@/features/permissions";
import { formatDate, formatNumber } from "@/features/shared";
import { UpstreamTransactionLink } from "@/features/ui";

export const PaymentHistorySection = ({ expenseAccrual }) => {
  const { hasPermission } = useAuth();
  const payments = expenseAccrual.payments || [];

  return (
    <Paper sx={{ p: 2.5, borderRadius: 2 }}>
      <Stack spacing={2}>
        <Typography variant="h6">Riwayat Pembayaran</Typography>

        <DataGrid
          rows={payments}
          getRowId={(row) => row.id}
          getRowHeight={() => "auto"}
          columns={[
            {
              field: "referenceNumber",
              headerName: "Nomor Referensi",
              flex: 1.5,
              sortable: false,
              renderCell: ({ value }) => (
                <UpstreamTransactionLink
                  referenceNumber={value}
                  shortReference={false}
                  clickable={hasPermission(PermissionEnum.READ_OTHER_PAYMENTS)}
                />
              ),
            },
            {
              field: "transactionDate",
              headerName: "Tanggal",
              flex: 1,
              sortable: false,
              valueGetter: (transactionDate) =>
                transactionDate ? formatDate(transactionDate) : "-",
            },
            {
              field: "payee",
              headerName: "Penerima",
              flex: 1.5,
              sortable: false,
              valueGetter: (payee) => payee || "-",
            },
            {
              field: "allocatedAmount",
              headerName: "Dibayar (Rp)",
              flex: 1.5,
              type: "number",
              sortable: false,
              valueFormatter: (value) => formatNumber(value),
            },
            {
              field: "note",
              headerName: "Catatan",
              flex: 2,
              sortable: false,
              valueGetter: (note) => note || "-",
            },
          ]}
          disableRowSelectionOnClick
          hideFooter
          localeText={{ noRowsLabel: "Belum ada pembayaran" }}
        />
      </Stack>
    </Paper>
  );
};

PaymentHistorySection.propTypes = {
  expenseAccrual: PropTypes.object.isRequired,
};
